import { render, staticRenderFns } from "./DeviceAlertsPage.vue?vue&type=template&id=25aeb778&"
import script from "./DeviceAlertsPage.vue?vue&type=script&lang=js&"
export * from "./DeviceAlertsPage.vue?vue&type=script&lang=js&"
import style0 from "./DeviceAlertsPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports